const { createBundleTiles } = require('../tiles/product-tile-factory'), { mergeInspirationTiles } = require('../tiles/merge-inspiration-tiles');

class BrowseTileListController {
    constructor($scope, $timeout, settings, shelfProductService, $location, pageMetadataService, richRelevanceService, breakpointsService, sortByKeys) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$location = $location;
        this.settings = settings;
        this.shelfProductService = shelfProductService;
        this.pageMetadataService = pageMetadataService;
        this.richRelevanceService = richRelevanceService;
        this.breakpointsService = breakpointsService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = {
            sortTypes: this.settings[this.category.IsSpecial ? 'specials' : 'browse'].sortOptions,
            sortContext: this.category.IsSpecial ? this.sortByKeys.SPECIALS_KEY : this.sortByKeys.BROWSE_KEY,
        };
    }

    createTiles(response, pageSize, pageNumber) {
        return {
            items: mergeInspirationTiles(createBundleTiles(response.Bundles), response.InspirationCards.Cards, { pageSize, pageNumber }),
            totalRecordCount: response.TotalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.getBrowsePage(pageSize, pageNumber, sortType)
            .then(response => this.setMetadata(response))
            .then(response => this.onPlacementsReceived(response))
            .then(response => this.createTiles(response, pageSize, pageNumber));
    }

    getBrowsePage(pageSize = 10, pageNumber, sortType) {
        return this.shelfProductService.getBrowsePage({
            categoryId: this.category.IsBundle ? this.category.ParentNodeId : this.category.NodeId,
            pageNumber,
            pageSize,
            sortType,
            url: this.$location.url(),
            formatObject: { name: this.category.Description },
            isSpecial: this.category.IsSpecial,
            isBundle: this.category.IsBundle,
            isMobile: this.breakpointsService.isInSmallFormat,
        });
    }

    setMetadata(response) {
        this.pageMetadataService.setMetadata(response.SeoMetaTags);

        return response;
    }

    onPlacementsReceived(response) {
        if (this.richRelevanceService.useServerSideResults(response.RichRelevancePlacement)) {
            this.richRelevanceService.onPlacementsReceived(response.RichRelevancePlacement);
        }

        return response;
    }
}

BrowseTileListController.$inject = ['$scope', '$timeout', 'Settings', 'ShelfProductService', '$location', 'PageMetadataService', 'RichRelevanceService', 'BreakpointsService', 'SortByKeys'];

const browseTileListComponentDefinition = {
    bindings: {
        category: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: BrowseTileListController,
    template: `
        <wow-tile-list
            list-title="::$ctrl.category.Description"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            should-get-inspiration-cards="false"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    BrowseTileListController,
    browseTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/browse-tile-list.component.js